import React, { Component } from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Autosuggest from "react-autosuggest";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import { taxServiceClient } from "../../AxiosClient";
import { withTranslation } from "react-i18next";
import Autocomplete from "@material-ui/lab/Autocomplete";

const styles = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  suggestionsContainerOpen: {
    position: "absolute",
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
    zIndex: 9999,
  },
  suggestion: {
    display: "block",
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },
  documentDialog: {
    minHeight: 400,
    minWidth: 400,
    overflow: "visible",
  },
});

export class TeamAutosuggest extends Component {
  state = {
    teamSuggestions: [],
    teamAutocompleteLoading: false,
    teamSuggestInput: "",
    value: "",
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Autocomplete
          handleHomeEndKeys
          fullWidth
          openOnFocus
          options={this.state.teamSuggestions}
          onChange={(e, selected) => {
            this.setState({ value: selected.teamName });
            this.props.onItemSelected(selected);
          }}
          getOptionSelected={(op, val) => {
            return op.teamName === val.teamName;
          }}
          renderOption={(option, { selected }) => (
            <Paper
              square
              elevation="0"
              style={{ width: "90%", marginLeft: 10, marginBottom: 10 }}
            >
              {option.teamName}
            </Paper>
          )}
          inputValue={this.state.value}
          onInputChange={this.handleTeamSuggestChange}
          getOptionLabel={(option) => option.teamName}
          renderInput={(params) => (
            <>
              <TextField
                {...params}
                variant="standard"
                label={this.props.t("team_autosuggest_choose")}
              />{" "}
              {this.state.topicAutocompleteLoading && (
                <LinearProgress color="secondary" />
              )}
            </>
          )}
        />
      </div>
    );
  }
  // getTeamSuggestionValue = (suggestion) => {
  //   return suggestion.teamName;
  // };

  handleTeamSuggestChange = (_e, newValue) => {
    if (_e && _e.type === "change") {
      this.props.onFilterChange(newValue);
      this.setState({ teamSuggestInput: newValue });
      this.onTeamSuggestionsFetchRequested(newValue);
    }
  };

  onTeamSuggestionsFetchRequested = (value) => {
    this.setState({ value });

    if (this.timeout) {
      // only need the latest request queued
      window.clearTimeout(this.timeout);
    }

    this.setState({ teamAutocompleteLoading: true });

    // queue the request so we don't machine gun them at the backend
    this.timeout = window.setTimeout(() => {
      taxServiceClient
        .get("/team/", {
          params: {
            search: value,
            orgId: this.props.organizationId,
          },
        })
        .then((res) => {
          this.setState({ teamSuggestions: res.data.content }, () =>
            this.setState({ teamAutocompleteLoading: false })
          );
          //if the input exactly matches a single result we select it
          res.data.content.length === 1 &&
            res.data.content[0].teamName === this.state.teamSuggestInput &&
            this.props.onItemSelected(res.data.content[0]);
        });
      // clear the queue
      this.timeout = null;
    }, 750);
  };

  // renderTeamSuggestion = (suggestion, { query, isHighlighted }) => {
  //   return (
  //     <MenuItem
  //       selected={isHighlighted}
  //       component="div"
  //       onClick={() => this.props.onItemSelected(suggestion)}
  //     >
  //       <Typography noWrap>{suggestion.teamName}</Typography>
  //     </MenuItem>
  //   );
  // };

  onTeamSuggestionsClearRequested = () => {
    this.setState({ teamSuggestions: [] });
  };
}
export default withStyles(styles)(withTranslation()(TeamAutosuggest));
